function isAvailable(): boolean {
  try {
    const test = "__storage_test__";
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch {
    return false;
  }
}

export function getJson<T>(key: string): T | null {
  if (!isAvailable()) return null;
  try {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
}

export function setJson<T>(key: string, value: T): boolean {
  if (!isAvailable()) return false;
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}

export function getJsonList<T>(key: string): T[] {
  return getJson<T[]>(key) ?? [];
}

export function setJsonList<T>(key: string, items: T[], maxEntries = 50): void {
  const trimmed = items.length > maxEntries ? items.slice(-maxEntries) : items;
  setJson(key, trimmed);
}
